import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../services/authentication.service';
import { Utilities } from '../services/utilities';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [MsalService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  title = 'Rada login';
  isIframe = false;
  loginDisplay = false;
  loadOtherComponents = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, 
    private broadcastService: MsalBroadcastService, 
    private msalAuthService: MsalService,
    private readonly authService: AuthenticationService,
    private readonly cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;

    this.broadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      takeUntil(this._destroying$)
    )
    .subscribe(() => {
      this.setLoginDisplay();
      if(!this.loginDisplay)
        this.login();
      else {
        this.authService.getSecureApiToken$().subscribe(x => {
          Utilities.processLoginResponse(x);

          if(this.isValidRoleAuthorization()) {
            this.loadOtherComponents = true;
            this.cdr.markForCheck();
          } else {
            this.msalAuthService.logout();
          }
        });
      }
    });
  }

  login() {
    if (this.msalGuardConfig.authRequest){
      this.msalAuthService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    } else {
      this.msalAuthService.loginRedirect();
    }
  }

  setLoginDisplay() {
    this.loginDisplay = this.msalAuthService.instance.getAllAccounts().length > 0;
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  isValidRoleAuthorization(): boolean {
    const user = JSON.parse(localStorage.getItem("current_user"));

    if(!user || !user.roles) {  // not logged in so redirect to login page with the return url
      this.msalAuthService.loginRedirect();
      return false;
    }

    const roles: string[] = environment.roles;
    if(roles.length == 0) { // no restrictions on any role so let user proceed
        return true;
    }

    const found = user.roles.some((r:string) => roles.includes(r));

    // check if route is restricted by role
    if (found) {
      // authorised so return true
      return true;
    }

    // role not authorised so redirect to home page
    console.error("Utente non ha il ruolo per poter accedere all'applicazione.");
    alert("Utente non ha le autorizzazioni necessarie per poter accedere all'applicazione.");
    return false;
  }
}
